import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer: React.FC = () => {
    return (
        <Box
        component="footer"
        sx={{
          textAlign: 'center',
          backgroundColor: '#0f63a5',
          color: 'text.secondary',
          display: 'flex', 
          justifyContent: 'center', 
          flexDirection: 'row', 
          alignItems: 'center',
          gap: 1
        }}
      >
        &copy; {new Date().getFullYear()} 
            <Typography variant="body2" display="block" gutterBottom sx={{mt: '5px',fontWeight:800 }}>
               RajivWilliams
            </Typography>
            
            <Typography variant="body2" display="block" gutterBottom sx={{mt: '5px', }}>
                All rights reserved.
            </Typography>
        </Box>
    );
};

export default Footer;